import { ReactNode } from 'react';

interface Props {
  label: string;
  value: ReactNode;
  /** Font Awesome 아이콘 클래스 (예: "fas fa-users") */
  icon: string;
  /** Tailwind border-l-4 색상 클래스 (예: "border-primary") */
  borderColor: string;
  /** 아이콘 텍스트 색상 클래스 (예: "text-primary") */
  iconColor: string;
  /** 아이콘 배경 색상 클래스 (예: "bg-primary/10") */
  bgColor: string;
  /** 숫자 텍스트 색상 클래스. 기본값: "text-gray-800" */
  valueColor?: string;
}

/**
 * 목록 페이지 상단의 집계 수치 카드.
 * AdverList·NoticeList에서 각 5개·4개 반복되던 동일 구조를 추출한 컴포넌트.
 */
export default function StatsCard({
  label, value, icon, borderColor, iconColor, bgColor, valueColor = 'text-gray-800',
}: Props) {
  return (
    <div className={`bg-white rounded-xl shadow-md p-5 border-l-4 ${borderColor}`}>
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm text-gray-500 font-medium">{label}</p>
          <p className={`text-3xl font-bold mt-1 ${valueColor}`}>{value}</p>
        </div>
        <div className={`w-12 h-12 ${bgColor} rounded-full flex items-center justify-center`}>
          <i className={`${icon} ${iconColor} text-xl`}></i>
        </div>
      </div>
    </div>
  );
}
